import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, FormWithRedirect, TextInput, Toolbar, required } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import CreatedByInput from "../../../../Components/ReferenceFields/CreatedBy/CreatedByInput";

const AircraftTypeEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput label="Active/Passive" source="isActive" />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput disabled fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em">
                    <Typography variant="h6" gutterBottom color="primary">
                      Updatable Field
                    </Typography>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={0.5} mr={{ xs: 0, sm: "1em" }}>
                      <TextInput
                        source="aircraftTypeCode"
                        label="Aircraft Type Code"
                        fullWidth
                        resettable
                        validate={[required()]}
                      />
                    </Box>
                    <Box flex={0.5} mr={{ xs: 0, sm: "1em" }}>
                      <TextInput
                        source="aircraftTypeName"
                        label="Aircraft Type Name"
                        fullWidth
                        resettable
                        validate={[required()]}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default AircraftTypeEditForm;
